import { type UseQueryResult, useQuery } from '@tanstack/react-query'
import type { components } from 'api/playerPayback/api'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetPatronProfileBadges = ({
  patronId,
}: {
  patronId: number
}): UseQueryResult<
  Array<components['schemas']['FullPatronBadgeRewardDTO']>
> => {
  const get = useTypedApiClient({
    path: '/admin/patrons/{patronId}/profilebadges',
    method: 'get',
  })

  return useQuery({
    queryKey: ['/admin/patrons/{patronId}/profilebadges', patronId],
    queryFn: async () => {
      const { data } = await get({ patronId })
      return data
    },
  })
}
